import { FivetranServiceEnum, salesforceSchema } from "@repo/fivetran/types";

import {
  DestinationField,
  DestinationSetupField,
  SchemaField,
} from "./connection-fields";
import { ConnectionFormShell } from "./connection-form-shell";
import {
  type ConnectionFormProps,
  useConnectionForm,
} from "./use-connection-form";

export const SalesforceFormPage = ({
  onConnected,
  onCancel,
}: ConnectionFormProps = {}) => {
  const { form, embedded, formId } = useConnectionForm({
    service: FivetranServiceEnum.enum.salesforce,
    schema: salesforceSchema,
    defaultConfig: { schema: FivetranServiceEnum.enum.salesforce },
    onConnected,
  });

  return (
    <ConnectionFormShell
      form={form}
      formId={formId}
      icon="salesforce"
      submitLabel="Authenticate"
      embedded={embedded}
      onCancel={onCancel}
    >
      <DestinationField form={form} />
      <DestinationSetupField form={form} />
      <SchemaField form={form} />
    </ConnectionFormShell>
  );
};
